import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { supabase } from '../../lib/supabase.js'

export default function ProtectedRoute({ children, requiredRole }) {
  const [state, setState] = useState({ session: undefined, role: null, checkedFor: undefined })

  useEffect(() => {
    async function check(session) {
      if (!session) {
        setState({ session: null, role: null, checkedFor: requiredRole ?? null })
        return
      }
      if (!requiredRole) {
        setState({ session, role: null, checkedFor: null })
        return
      }
      const { data } = await supabase
        .from('profiles')
        .select('role')
        .eq('id', session.user.id)
        .single()
      setState({ session, role: data?.role ?? null, checkedFor: requiredRole })
    }

    supabase.auth.getSession().then(({ data: { session } }) => check(session))

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      check(session)
    })
    return () => subscription.unsubscribe()
  }, [requiredRole])

  // Attend que la vérification soit complète pour le requiredRole courant avant de décider
  if (state.checkedFor !== (requiredRole ?? null)) return null
  if (!state.session) return <Navigate to="/login" replace />
  if (requiredRole && state.role !== requiredRole) return <Navigate to="/home" replace />
  return children
}
